import { ExportIcon } from "assets/svgs";
import CommonButton from "components/common/commonButton/Button";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import React from "react";
import ExplicitIcon from '@mui/icons-material/Explicit';
import { useTranslation } from "react-i18next";

interface IExportButton {
  url: string;
  fileName?: string;
}

const parseUrl = (url: string) => {
  const [path, queryString] = url.split("?");
  const params = new URLSearchParams(queryString);
  const queryObj: Record<string, any> = {};
  params.forEach((value, key) => {
    const num = Number(value);
    queryObj[key] = isNaN(num) ? value : num; // Agar raqam bo'lsa, number qilib saqlaymiz
  });
  return { path, queryObj };
};

export const downlaodFileByName = async ({
  fileUrl,
  fileName,
}: {
  fileUrl: string;
  fileName: string;
}) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/" + fileUrl
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("File download error:", error);
  }
};

const ExportButton = ({ url, fileName }: IExportButton) => {
  const { t } = useTranslation();
  const { path, queryObj } = parseUrl(url);

  const { mutate, status } = useApiMutation(path, "post", {
    onSuccess(data) {
      if (data) {
        downlaodFileByName({
          fileUrl: data?.data as string,
          fileName: fileName || "appropriation",
        });
      }
    },
  });

  return (
    <CommonButton
      className="complete"
      title={status === "loading" ? t("general.export")+"..." : t("general.export")!}
      onClick={() => mutate(queryObj)}
      startIcon={<ExplicitIcon style={{ fontSize: "25px" }} />}
      status={status}
      disabled={status === "loading"}
    />
  );
};

export default ExportButton;
